import * as Yup from "yup";
import dayjs from "dayjs";

export const initialValues = {
    forceSave: false,
    movementTypeList: [],
    effectiveDate: dayjs(),
    remark: "",
};

const employeeEmploymentModalSchema = Yup.object().shape({
    effectiveDate: Yup.string().required("Please select start date."),
});

export default employeeEmploymentModalSchema;